import React from 'react';
import Udesk from 'Udesk';
import { getCurrentRouteName } from 'Udesk/system/subApp';
import { getCompanysBillingToken } from 'src/api/companys/billing/token';

// 计费系统按集群部署，region 由签名接口返回；S1 为主站（域名不带区域前缀），
// 测试集群（region 为 staging，如 s-qa1）与 t1 共用同一套计费地址，
// 未配置计费地址的集群（如 s9）不在此表中，页面降级为不可用提示
const BILLING_DOMAIN_BY_REGION = {
    staging: 'https://39.106.208.100',
    s1: 'https://billing.udesk.cn',
    s2: 'https://billing.s2.udesk.cn',
    s4: 'https://billing.s4.udesk.cn',
    s5: 'https://billing.s5.udesk.cn',
    t1: 'https://39.106.208.100',
};

// 计费系统发布的 sdk 资源路径
const BILLING_SDK_PATH = 'billing-paas-sdk/billing-tenant-sdk/1.0.0';

function getBillingDomain(region) {
    if (!region) {
        return '';
    }
    return BILLING_DOMAIN_BY_REGION[`${region}`.toLowerCase()] || '';
}

/** 取签名接口返回的原始信息，页面加载与 sdk 取 token 都用它 */
function fetchBillingTokenInfo() {
    return getCompanysBillingToken().then((resp) => (resp && resp.data) || {});
}

/** billing-tenant-sdk 只认 { appId, timestamp, sign }，会拼到计费接口的 query 上 */
function getSdkToken() {
    return fetchBillingTokenInfo().then((tokenInfo) => ({
        appId: tokenInfo.billingId,
        timestamp: tokenInfo.timestamp,
        sign: tokenInfo.sign,
    }));
}

function getMethodsLog(text, type) {
    switch (type) {
        case 'success':
            Udesk.ui.notify.success(`${text}`);
            break;
        case 'warning':
            Udesk.ui.notify.warn(`${text}`);
            break;
        case 'info':
            Udesk.ui.notify.info(`${text}`);
            break;
        case 'danger':
            Udesk.ui.notify.error(`${text}`);
            break;
        default:
            break;
    }
}

export default class FinanceCenterComponent extends React.Component {
    state = {
        releaseVersionUrl: '',
        billingSdkJsUrl: '',
        billingSdkCssUrl: '',
        // 集群未开通计费 / 无计费地址时降级提示
        unavailable: false,
    };

    privates = {
        renderContainerId: 'finance-center-sdk-container',
        appId: '',
        billingDomain: '',
        billingSdkInstance: null,
    };

    componentDidMount() {
        this.actions.loadBillingToken();
    }

    componentWillUnmount() {
        this.actions.destroyBillingSdk();
    }

    actions = {
        loadBillingToken() {
            fetchBillingTokenInfo().then(
                (tokenInfo) => {
                    const billingDomain = getBillingDomain(tokenInfo.region);
                    if (!tokenInfo.billingId || !billingDomain) {
                        // 未开通计费或该集群无计费地址，打印 region 便于排查
                        Udesk.logger.warn(
                            `[finance-center] billing is unavailable, region: ${tokenInfo.region}`
                        );
                        this.setState({ unavailable: true });
                        return;
                    }
                    this.privates.appId = tokenInfo.billingId;
                    this.privates.billingDomain = billingDomain;
                    this.setState({
                        releaseVersionUrl: `${billingDomain}/RELEASE-VERSION`,
                        billingSdkJsUrl: `${billingDomain}/${BILLING_SDK_PATH}/sdk.js`,
                        billingSdkCssUrl: `${billingDomain}/${BILLING_SDK_PATH}/sdk.css`,
                    });
                },
                () => {
                    this.setState({ unavailable: true });
                }
            );
        },

        getRenderToOptions() {
            const { appId, billingDomain } = this.privates;
            // rootRoute 取当前子应用注册的页面路径，而不是 location.pathname：
            // sdk 会在其后追加内部路由，深层地址刷新时才不会把子路径当根路径
            const rootRoute = Udesk.ui.routing.getRoutePath({
                routeName: getCurrentRouteName('financeCenterIndex'),
            });
            return {
                props: {
                    domain: `${billingDomain}/billing/v1`,
                    rootRoute,
                    // 直接落在本租户的账务详情：账户详情（含余额）、记录明细（充值/消费）
                    landingPath: `/record/details/${appId}`,
                    companyId: appId,
                    language: Udesk.data.init.userLanguage,
                    releaseVersionUrl: this.state.releaseVersionUrl,
                },
                configs: {
                    settings: {
                        hideCompanyDetailBack: false,
                        companyDetailTitle: this.locales.components.pages.financeCenter.title
                    },
                },
                methods: {
                    log: getMethodsLog,
                    // 签名五分钟过期，sdk 每次按需取时都实时请求新签名
                    getToken: getSdkToken,
                },
            };
        },

        onLoaded(SdkClass) {
            const container = document.getElementById(this.privates.renderContainerId);
            if (!container) {
                return;
            }
            const billingSdkInstance = new SdkClass(this.actions.getRenderToOptions());
            billingSdkInstance.renderTo(container);
            this.privates.billingSdkInstance = billingSdkInstance;
        },

        destroyBillingSdk() {
            const { billingSdkInstance } = this.privates;
            if (billingSdkInstance && typeof billingSdkInstance.destroy === 'function') {
                billingSdkInstance.destroy();
            }
            this.privates.billingSdkInstance = null;
        },
    };
}
